import React from 'react';

export const DocumentCompletionBanner: React.FC = () => {
  return (
    <div className="flex justify-center items-center mt-6 mb-4">
      <p className="rounded-full px-8 py-6 text-sm font-bold bg-green-50 text-green-500 ring-green-600/20">
        L'assuré a reçu tous les documents.
      </p>
    </div>
  );
};
